/**
 * Sticky Add to Cart: show only when main PDP .product-form__submit is above the screen (scrolled past);
 * hide when cart drawer is open; sync loading state; body class for layout (e.g. tww_sidebar).
 */
(function () {
  var stickyEl = document.getElementById('StickyAddToCart');
  var stickyBtn = document.getElementById('StickyProductSubmit');
  if (!stickyEl || !stickyBtn) return;

  /**
   * Main PDP submit button only (inside product-info, so we don't pick quick-add/card forms).
   * Sticky bar is outside product-info so it's never returned.
   */
  function getMainSubmitButton() {
    var productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    if (!productInfo) return null;
    var form = productInfo.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return null;
    return form.querySelector('.product-form__submit') || form.querySelector('button[type="submit"]');
  }

  var isCartDrawerOpen = false;

  /** Update body class for layout (e.g. .sticky-add-to-cart--active .tww_sidebar_container). */
  function setBodyStickyActive(active) {
    if (active) {
      document.body.classList.add('sticky-add-to-cart--active');
    } else {
      document.body.classList.remove('sticky-add-to-cart--active');
    }
  }

  /** Set sticky bar visibility: show only when main submit is above viewport (scrolled past) and cart drawer is closed. */
  function updateStickyVisibility(submitAboveViewport) {
    if (isCartDrawerOpen) {
      stickyEl.classList.remove('show');
      setBodyStickyActive(false);
    } else if (submitAboveViewport) {
      stickyEl.classList.add('show');
      setBodyStickyActive(true);
    } else {
      stickyEl.classList.remove('show');
      setBodyStickyActive(false);
    }
  }

  /** True when main submit is above the screen (user has scrolled past it). */
  function isSubmitAboveViewport(rect) {
    return rect.bottom < 0;
  }

  /** Sync sticky button loading state from main submit. */
  function syncStickyLoadingState() {
    var mainSubmit = getMainSubmitButton();
    if (!mainSubmit) return;
    var isLoading = mainSubmit.classList.contains('loading');
    var spinner = stickyBtn.querySelector('.loading__spinner');
    if (isLoading) {
      stickyBtn.classList.add('loading');
      stickyBtn.disabled = true;
      if (spinner) spinner.classList.remove('hidden');
    } else {
      stickyBtn.classList.remove('loading');
      // Keep mirroring the main button's disabled state (syncStickyButton adds the
      // 'disabled' class) — e.g. the fc dropdown cart lock applies during the add.
      stickyBtn.disabled = stickyBtn.classList.contains('disabled');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  /** Toggle sticky bar visibility: show when main .product-form__submit is not visible on screen. */
  function initVisibility() {
    var mainSubmit = getMainSubmitButton();
    if (!mainSubmit) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var rect = entry.target.getBoundingClientRect();
          updateStickyVisibility(isSubmitAboveViewport(rect));
        });
      },
      { root: null, rootMargin: '0px', threshold: 0 }
    );
    observer.observe(mainSubmit);

    /** Initial state: show only if main submit is above viewport and drawer closed. */
    var rect = mainSubmit.getBoundingClientRect();
    updateStickyVisibility(isSubmitAboveViewport(rect));

    /** Watch main submit for loading class changes and sync to sticky button. */
    var loadingObserver = new MutationObserver(function () {
      syncStickyLoadingState();
    });
    loadingObserver.observe(mainSubmit, { attributes: true, attributeFilter: ['class'] });
    syncStickyLoadingState();
  }

  /** Watch cart drawer open/close (this theme uses class "active"). */
  function initCartDrawerWatch() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    function checkDrawer() {
      isCartDrawerOpen = cartDrawer.classList.contains('active');
      var mainSubmit = getMainSubmitButton();
      var above = mainSubmit ? isSubmitAboveViewport(mainSubmit.getBoundingClientRect()) : false;
      updateStickyVisibility(above);
    }
    var drawerObserver = new MutationObserver(function () {
      checkDrawer();
    });
    drawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    checkDrawer();
  }

  /**
   * fc-product-dropdown-v1 template: sticky mirrors the dropdown selections.
   * Two selections -> bundle layout (two thumbnails + summed price); one
   * selection -> single layout showing that product. ATC needs no changes here:
   * the sticky button submits the main form, which product-form.js resolves
   * from the same selections.
   */
  function syncStickyDropdowns(dropdowns, singleBlock, bundleBlock) {
    var selected = Array.prototype.slice
      .call(dropdowns.querySelectorAll('[data-dropdown-option][aria-selected="true"]'))
      .filter(function (option) {
        return !option.disabled && option.dataset.variantId;
      });
    if (!selected.length) return;

    stickyEl.classList.add('sticky-add-to-cart--fc-dropdowns');

    var formatter = new Intl.NumberFormat(document.documentElement.lang || 'nl', {
      style: 'currency',
      currency: dropdowns.getAttribute('data-currency') || 'EUR',
    });
    var total = 0;
    selected.forEach(function (option) {
      total += parseInt(option.dataset.price, 10) || 0;
    });

    function optionImg(option) {
      return option.querySelector('[data-option-content] img');
    }

    if (selected.length > 1) {
      singleBlock.style.display = 'none';
      bundleBlock.style.display = 'flex';
      var stickyImg1 = stickyEl.querySelector('[data-sticky-bundle-image-1]');
      var stickyImg2 = stickyEl.querySelector('[data-sticky-bundle-image-2]');
      var stickyFrame = stickyEl.querySelector('[data-sticky-bundle-frame]');
      var img1 = optionImg(selected[0]);
      var img2 = optionImg(selected[1]);
      if (img1 && stickyImg1) {
        stickyImg1.src = img1.src;
        stickyImg1.alt = img1.alt || '';
      }
      if (img2 && stickyImg2) {
        stickyImg2.src = img2.src;
        stickyImg2.alt = img2.alt || '';
        stickyImg2.classList.remove('hidden');
      }
      if (stickyFrame) stickyFrame.classList.add('hidden');
      var bundleLabelEl = stickyEl.querySelector('[data-sticky-bundle-label]');
      var singleTitleEl = stickyEl.querySelector('[data-sticky-title]');
      if (bundleLabelEl && singleTitleEl) bundleLabelEl.textContent = singleTitleEl.textContent.trim();
      var bundlePriceEl = stickyEl.querySelector('[data-sticky-bundle-price]');
      if (bundlePriceEl) bundlePriceEl.textContent = formatter.format(total / 100);
    } else {
      singleBlock.style.display = 'flex';
      bundleBlock.style.display = 'none';
      var img = optionImg(selected[0]);
      var stickyImg = stickyEl.querySelector('[data-sticky-image]');
      if (img && stickyImg) {
        stickyImg.src = img.src;
        stickyImg.alt = img.alt || '';
      }
      var priceEl = stickyEl.querySelector('[data-sticky-price-original]');
      if (priceEl) priceEl.textContent = formatter.format(total / 100);
      var compareEl = stickyEl.querySelector('[data-sticky-price-compare]');
      if (compareEl) {
        var compare = parseInt(selected[0].dataset.comparePrice, 10) || 0;
        if (compare > total) {
          compareEl.textContent = formatter.format(compare / 100);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    }
  }

  /** Show single or bundle layout and sync content. No .pdp-pref = single layout. */
  function syncStickyLayout() {
    var pref = document.querySelector('.pdp-pref');
    var singleBlock = stickyEl.querySelector('[data-sticky-single]');
    var bundleBlock = stickyEl.querySelector('[data-sticky-bundle]');
    if (!singleBlock || !bundleBlock) return;

    var dropdowns = document.querySelector('.pdp-dropdowns');
    if (dropdowns) {
      syncStickyDropdowns(dropdowns, singleBlock, bundleBlock);
      return;
    }

    var activeOption = pref ? pref.querySelector('[data-option].active') : null;
    var optionValue = activeOption ? activeOption.getAttribute('data-option') : 'single';

    if (optionValue === 'bundle' && pref) {
      singleBlock.style.display = 'none';
      bundleBlock.style.display = 'flex';
      var bundleOption = pref.querySelector('[data-bundle-option].active');
      if (bundleOption) {
        var priceEl = bundleOption.querySelector('.pdp-pref__option-price');
        var bundlePriceEl = stickyEl.querySelector('[data-sticky-bundle-price]');
        if (priceEl && bundlePriceEl) bundlePriceEl.textContent = priceEl.textContent.trim();
        var labelEl = bundleOption.querySelector('.pdp-pref__option-header .pdp-pref__option-text');
        var bundleLabelEl = stickyEl.querySelector('[data-sticky-bundle-label]');
        if (labelEl && bundleLabelEl) bundleLabelEl.textContent = labelEl.textContent.trim();
        var singleImageSpans = bundleOption.querySelectorAll('.pdp-pref__option-image:not([data-add-bundle-button])');
        var img1 = singleImageSpans[0] ? singleImageSpans[0].querySelector('img') : null;
        var addedBundleImageEl = bundleOption.querySelector('[data-added-bundle-image]');
        var addBundleButtonEl = bundleOption.querySelector('[data-add-bundle-button]');
        var addedBundleImageHasHidden = addedBundleImageEl && addedBundleImageEl.classList.contains('hidden');
        var addBundleButtonHasHidden = addBundleButtonEl && addBundleButtonEl.classList.contains('hidden');
        var isTrialKit = bundleOption.getAttribute('data-bundle-option') === 'trial-kit';
        var stickyImg1 = stickyEl.querySelector('[data-sticky-bundle-image-1]');
        var stickyImg2 = stickyEl.querySelector('[data-sticky-bundle-image-2]');
        var stickyImg2Wrapper = stickyEl.querySelector('[data-sticky-bundle-image-2-wrapper]');
        var stickyFrame = stickyEl.querySelector('[data-sticky-bundle-frame]');
        if (img1 && stickyImg1) {
          stickyImg1.src = img1.src || img1.getAttribute('src') || '';
          stickyImg1.alt = img1.alt || '';
        }
        if (stickyFrame && stickyImg2) {
          if (isTrialKit) {
            if (addedBundleImageHasHidden) {
              stickyFrame.classList.remove('hidden');
              stickyImg2.classList.add('hidden');
            } else if (addBundleButtonHasHidden) {
              var addedImg = addedBundleImageEl ? addedBundleImageEl.querySelector('img') : null;
              if (addedImg) {
                stickyImg2.src = addedImg.src || addedImg.getAttribute('src') || '';
                stickyImg2.alt = addedImg.alt || '';
              }
              stickyFrame.classList.add('hidden');
              stickyImg2.classList.remove('hidden');
            }
          } else {
            var img2 = singleImageSpans[1] ? singleImageSpans[1].querySelector('img') : null;
            if (img2) {
              stickyImg2.src = img2.src || img2.getAttribute('src') || '';
              stickyImg2.alt = img2.alt || '';
            }
            stickyFrame.classList.add('hidden');
            stickyImg2.classList.remove('hidden');
          }
        }
        if (stickyImg2Wrapper) {
          if (isTrialKit && addBundleButtonEl && addedBundleImageHasHidden) {
            stickyImg2Wrapper.setAttribute('data-sticky-add-bundle-trigger', 'true');
            stickyImg2Wrapper.classList.add('sticky-add-to-cart__image-wrapper--clickable');
          } else {
            stickyImg2Wrapper.removeAttribute('data-sticky-add-bundle-trigger');
            stickyImg2Wrapper.classList.remove('sticky-add-to-cart__image-wrapper--clickable');
          }
        }
      }
    } else {
      singleBlock.style.display = 'flex';
      bundleBlock.style.display = 'none';
    }
  }

  /** Get current price/compare nodes from the visible PDP option (single or bundle). */
  function getVisiblePriceNodes() {
    var pref = document.querySelector('.pdp-pref');
    if (!pref) return null;

    var activeContent = pref.querySelector('[data-option-content].active');
    if (!activeContent) return null;

    var option = activeContent.getAttribute('data-option-content');
    if (option === 'single') {
      var checked = activeContent.querySelector('.pdp-pref__variant-input:checked');
      var variantBlock = checked && checked.closest('.pdp-pref__variant');
      if (!variantBlock) return null;
      var priceBlock = variantBlock.querySelector('.price');
      if (!priceBlock) return null;
      var salePrice = priceBlock.querySelector('.price__sale .price-item--last, .price__sale .price-item--sale');
      var regularPrice = priceBlock.querySelector('.price__regular .price-item--regular');
      var original = salePrice || regularPrice || priceBlock.querySelector('.price-item');
      var compare = priceBlock.querySelector('.price__sale s.price-item--regular, .price__sale .variant-item__old-price');
      return { original: original, compare: compare || null };
    }
    if (option === 'bundle') {
      var bundleOption = pref.querySelector('[data-bundle-option].active');
      var priceEl = bundleOption && bundleOption.querySelector('.pdp-pref__option-price');
      if (!priceEl) return null;
      return { original: priceEl, compare: null };
    }
    return null;
  }

  /** Update sticky bar price from visible PDP content (single or bundle). */
  function syncStickyPrice() {
    var originalEl = stickyEl.querySelector('[data-sticky-price-original]');
    var compareEl = stickyEl.querySelector('[data-sticky-price-compare]');
    if (!originalEl) return;

    var nodes = getVisiblePriceNodes();
    if (nodes && nodes.original) {
      originalEl.textContent = nodes.original.textContent.trim();
      if (compareEl && nodes.compare) {
        compareEl.textContent = nodes.compare.textContent.trim();
        compareEl.style.display = '';
      } else if (compareEl) {
        compareEl.style.display = 'none';
      }
    }
  }

  /** Sync sticky button to mirror main .product-form__submit: disabled, label, primary/secondary class. */
  function syncStickyButton() {
    var mainSubmit = getMainSubmitButton();
    if (!mainSubmit) return;
    var disabled = mainSubmit.hasAttribute('disabled') || mainSubmit.getAttribute('aria-disabled') === 'true';
    var labelSpan = stickyBtn.querySelector('[data-sticky-label]') || stickyBtn.querySelector('span:first-child');
    if (labelSpan) {
      var mainSoldOut = mainSubmit.querySelector('.sold-out-message');
      var mainText = (mainSoldOut && mainSoldOut.classList && !mainSoldOut.classList.contains('hidden'))
        ? mainSoldOut.textContent
        : (mainSubmit.querySelector('span') ? mainSubmit.querySelector('span').textContent : '');
      if (mainText) {
        // The sticky always shows the short label ("In winkelwagen") for the standard
        // add-to-cart text, but mirrors state texts (sold out / unavailable) verbatim.
        var defaultLabel =
          window.variantStrings && window.variantStrings.addToCart ? window.variantStrings.addToCart.trim() : '';
        var shortLabel = labelSpan.getAttribute('data-short-label');
        labelSpan.textContent =
          mainText.trim() === defaultLabel && shortLabel ? shortLabel : mainText.trim();
      }
    }
    if (disabled) {
      stickyBtn.classList.add('disabled');
      stickyBtn.setAttribute('aria-disabled', 'true');
      stickyBtn.disabled = true;
    } else {
      stickyBtn.classList.remove('disabled');
      stickyBtn.removeAttribute('aria-disabled');
      if (!stickyBtn.classList.contains('loading')) stickyBtn.disabled = false;
    }
    if (mainSubmit.classList.contains('button--secondary')) {
      stickyBtn.classList.remove('button--primary');
      stickyBtn.classList.add('button--secondary');
    } else {
      stickyBtn.classList.remove('button--secondary');
      stickyBtn.classList.add('button--primary');
    }
  }

  /** Sticky button click: trigger main PDP form submit (same as clicking main ATC). */
  function onStickyButtonClick(e) {
    e.preventDefault();
    if (stickyBtn.classList.contains('disabled') || stickyBtn.classList.contains('loading') || stickyBtn.disabled) return;
    var mainSubmit = getMainSubmitButton();
    if (!mainSubmit) return;
    var form = mainSubmit.closest('form');
    if (form && typeof form.requestSubmit === 'function') {
      form.requestSubmit(mainSubmit);
    } else {
      mainSubmit.click();
    }
  }

  /** Listen for PDP option changes (Alleen het product / Bundel en bespaar). */
  function initOptionSync() {
    var pref = document.querySelector('.pdp-pref');
    if (!pref) return;
    pref.querySelectorAll('[data-option]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        setTimeout(function () {
          syncStickyLayout();
          syncStickyPrice();
          syncStickyButton();
        }, 50);
      });
    });
    pref.querySelectorAll('[data-bundle-option]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        setTimeout(function () {
          syncStickyLayout();
          syncStickyPrice();
          syncStickyButton();
        }, 50);
      });
    });
    var addedBundleEl = pref.querySelector('[data-added-bundle-image]');
    if (addedBundleEl) {
      var bundleObs = new MutationObserver(function () {
        syncStickyLayout();
      });
      bundleObs.observe(addedBundleEl, { attributes: true, attributeFilter: ['class'] });
    }
    pref.querySelectorAll('[data-remove-bundle-button]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(function () {
          syncStickyLayout();
          syncStickyPrice();
        }, 50);
      });
    });
  }

  /** Run when product info updates (variant change). */
  function onProductInfoUpdate() {
    syncStickyLayout();
    syncStickyPrice();
    syncStickyButton();
  }

  /** Re-check visibility from scroll (fallback if IntersectionObserver misses). */
  var scrollTick = null;
  function onScroll() {
    if (scrollTick) return;
    scrollTick = requestAnimationFrame(function () {
      scrollTick = null;
      var mainSubmit = getMainSubmitButton();
      if (mainSubmit) {
        var rect = mainSubmit.getBoundingClientRect();
        updateStickyVisibility(isSubmitAboveViewport(rect));
      }
    });
  }

  function runInits() {
    initVisibility();
    initCartDrawerWatch();
    initOptionSync();
    syncStickyLayout();
    syncStickyPrice();
    syncStickyButton();
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /** Retry initVisibility until main form exists (e.g. section loaded late), max 20 attempts. */
  function runVisibilityWithRetry(attempt) {
    attempt = attempt || 0;
    if (attempt > 20) return;
    var mainSubmit = getMainSubmitButton();
    if (mainSubmit) {
      initVisibility();
      return;
    }
    setTimeout(function () {
      runVisibilityWithRetry(attempt + 1);
    }, 150);
  }

  document.addEventListener('product-info:loaded', runInits);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runInits();
      setTimeout(runInits, 100);
      runVisibilityWithRetry();
    });
  } else {
    runInits();
    setTimeout(runInits, 100);
    runVisibilityWithRetry();
  }
  window.addEventListener('load', function () {
    runVisibilityWithRetry();
  });

  stickyBtn.addEventListener('click', onStickyButtonClick);

  /** fc dropdown template: re-sync thumbnails/price when a dropdown selection changes. */
  document.addEventListener('pdp-dropdown:change', function () {
    syncStickyLayout();
    syncStickyButton();
  });

  /** Click on sticky second image (frame) when Trial Kit has no bundle: open add-bundle pop. */
  stickyEl.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sticky-add-bundle-trigger="true"]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var pref = document.querySelector('.pdp-pref');
    var addBundleBtn = pref ? pref.querySelector('[data-add-bundle-button]') : null;
    if (addBundleBtn) addBundleBtn.click();
  });

  // Sync when variant or section updates (theme may re-render product form)
  if (typeof subscribe !== 'undefined' && typeof window.PUB_SUB_EVENTS !== 'undefined' && window.PUB_SUB_EVENTS.optionValueSelectionChange) {
    subscribe(window.PUB_SUB_EVENTS.optionValueSelectionChange, function () {
      setTimeout(onProductInfoUpdate, 300);
    });
  }
})();
